import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import PropTypes from "prop-types";
import Link from "components/ExtendLink";
import React from 'react';
import moment from "moment";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row
} from "reactstrap";
import callingIcon from "../../../files/called.png";
import userImage from "../../../files/user.png";
import LottieLoader from '../../LottieLoader';
import lottieEmptyFile from '../../../files/animation/empty_new.json';
import lottieLoaderFile from '../../../files/animation/loading.json';
const _ = require("lodash");

function fullname(cell, row) {
  const profile = row.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.profileImage : userImage;
  // return <UserName user={row} />;
  return (
    <div className={row.isActive ? "" : " text-danger"}>
      <span>
        <img src={profile} className="mr-2" alt="image"   
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = userImage;
        }}/>
        {capitalize(row.lname)}
        {", "}
        {capitalize(row.fname)}

        {row?.ccmTrackings?.length > 0 && <img src={callingIcon} />}
      </span>
    </div>
  );
}

function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}

function getSenderUser(cell) {
  if (!cell) return {};
  if (Array.isArray(cell) && cell.length > 0) return cell[0] || {};
  if (cell && typeof cell === 'object') {
    if (cell.user) return cell.user;
    return cell;
  }
  return {};
}

function formatSenderDisplayName(cell) {
  if (!cell) return '-';
  if (typeof cell === 'string') return cell;
  const user = getSenderUser(cell);
  const last = user && user.lname ? capitalize(user.lname) : "";
  const first = user && user.fname ? capitalize(user.fname) : "";
  return (last || first) ? [last, first].filter(Boolean).join(', ') : '-';
}

function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}

const ImprovedPatientList = (props, context) => {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    page: parseInt(props.page),
    sizePerPage: parseInt(props.sizePerPage),
    totalSize: parseInt(props.totalSize),
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    hideSizePerPage: props.displayNeedToFollowUpList ? true : parseInt(props.totalSize) == 0 ? true : false, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    showTotal: parseInt(props.totalSize) == 0 ? false : true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "100",
        value: 100
      },
      {
        text: "200",
        value: 200
      }
    ]
  };
  const columns = [
    {
      dataField: "lname",
      text: "Last, First Name",
      formatter: fullname,
      csvFormatter: (cell, row) => {
        return (
          row.lname +
          ", " +
          row.fname +
          ` (${row.isActive ? "ACTIVE" : "INACTIVE"})`
        );
      },
      sort: true,
      // filterValue: (cell, row) => {
      //   return row.lname + ", " + row.fname;
      // },
      headerFormatter: priceFormatter
      // hidden: props.displayCellularConnectivityList ? true : false,
      // csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "bday",
      text: "DOB",
      formatter: (cell, row) => {
        return moment(row.bday).format("MMMM DD, YYYY");
      },
      csvFormatter: (cell, row) => {
        return moment(row.bday).format("MMMM DD, YYYY");
      },
      sort: true,
      onSort: (field, order) => {
      }
      //hidden: props.displayCellularConnectivityList ? true : false,
      //csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "createdAt",
      text: "Enrolled Date",
      sort: true,
      formatter: (cell, row) => {
        return moment(row.createdAt).tz(moment.tz.guess()).format("MMMM DD, YYYY");
      },
      headerFormatter: priceFormatter,
      csvFormatter: (cell, row, rowIndex) => {
        return moment(row.createdAt).tz(moment.tz.guess()).format("MMMM DD, YYYY");
      },
      //hidden: props.displayCellularConnectivityList ? true : false,
      //csvExport: props.displayCellularConnectivityList ? false : true
    },
     {
      dataField: "phone",
      text: "Phone Number",
      sort: true,
      formatter: (cell, row) => {
        return row && row.phone ? row.phone : '-';
      },
      headerFormatter: priceFormatter,
      csvFormatter: (cell, row, rowIndex) => {
        return row && row.phone ? row.phone : '-';
      },
    },
    {
      dataField: "deviceReadingDate",
      text:
        props.displayActiveList === true || props.displayActiveList === null
          ? "Last Upload Date"
          : "Deactivated Date",
      sort: false,
      formatter: (cell, row) => {
        if (
          props.displayActiveList === true ||
          props.displayActiveList === null
        ) {
          if (row.deviceReadingDate && row.deviceReadingDate) {
            return moment(row.deviceReadingDate).tz(moment.tz.guess()).format(
              "MMMM DD, YYYY"
            );
          }
          return "NONE";
        } else if (props.displayActiveList === false) {
          return row.inActiveAt ? moment(row.inActiveAt).tz(moment.tz.guess()).format("MMMM DD, YYYY") : '-';
        }
      },
      csvFormatter: (cell, row) => {
        if (
          props.displayActiveList === true ||
          props.displayActiveList === null
        ) {
          if (row.lastReading && row.lastReading.deviceReadingDate) {
            return moment(row.lastReading.deviceReadingDate).format(
              "MMMM DD, YYYY"
            );
          }
          return "NONE";
        } else if (props.displayActiveList === false) {
          return row.inActiveAt ? moment(row.inActiveAt).tz(moment.tz.guess()).format("MMMM DD, YYYY") : '-';
        }
      },
      //hidden: props.displayCellularConnectivityList ? true : false,
      //csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "lastNoteDate",
      text:  "Date of Last Note" ,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: '160px', textAlign: 'left' };
      },
      headerFormatter: priceFormatter,
      formatter: (cell, row) => {
        if(cell && row && row.lastNote){
          const note = row.lastNote;
          return (
            <div>
              <span>{moment(note.createdAt).format("MMMM DD, YYYY hh:mm A")}</span>
              <span style={{fontWeight:800}}><br></br><br></br>{note.subject ? note.subject : <div className='text-center'>-</div>}</span>
            </div>
          )
        }else{
          return <div className="text-center">-</div>
        }
      },
    },
    {
      dataField: (props.displayFollowUpReminderList || props.displayReminderSentList  || props.displayMonthlyCheckInPhoneCall || props.displayfollowUpPhoneCall)  ? "lastNoteReminderDate" : "lastSelectedTabNoteDate",
      text: props.displayWinsPositiveOutcome ? "Date of Last WINS Note" : props.displayItIssuesList ? "Date of Last IT Issue Note" : (props.displayFollowUpReminderList || props.displayMonthlyCheckInPhoneCall || props.displayfollowUpPhoneCall) ?  'Follow Up Reminder Date' : props.displayReminderSentList ? 'Follow Up Reminder Sent Date' : (props.displayNeedToFollowUpList) ? 'Follow Up Created Date' : props.displayHospitalAddmissionList ? 'Hospital Admit Created Date'  :"Date of Last Note" ,
      sort: true,    
      order: 'asc', 
      headerStyle: (colum, colIndex) => {
        return { width: '160px', textAlign: 'left' };
      },
      headerFormatter: priceFormatter,
      formatter: (cell, row) => {
        if(props.displayFollowUpReminderList || props.displayReminderSentList || props.displayMonthlyCheckInPhoneCall || props.displayfollowUpPhoneCall){
          if (row.lastNoteReminderDate) {
            return row.lastNoteReminderDate ? (
              <div>
                <span>{moment(row.lastNoteReminderDate).format("MMMM DD, YYYY  hh:mm A")}</span>
                <span style={{fontWeight:800}}><br></br><br></br>{row.lastReminderNoteSubject ? row.lastReminderNoteSubject : <div className='text-center'>-</div>}</span>
              </div>
            ) : <div className='text-center'>-</div>;
          } else{
            return <div className="text-center">-</div>
          }
        } else{
          if (row.lastSelectedTabNoteDate) {
            return row.lastSelectedTabNoteDate ? (
              <div>
                <span>{moment(row.lastSelectedTabNoteDate).format("MMMM DD, YYYY hh:mm A")}</span>
                <span style={{fontWeight:800}}><br></br><br></br>{row.lastSelectedTabNoteSubject ? row.lastSelectedTabNoteSubject : <div className='text-center'>-</div>}</span>
              </div>
            ) : <div className='text-center'>-</div>;
          } else{
            return <div className="text-center">-</div>
          }
        }
      },
      hidden: props.displayNeedToFollowUpList || props.displayHospitalAddmissionList || props.displayItIssuesList || props.displayFollowUpReminderList || props.displayReminderSentList || props.displayMonthlyCheckInPhoneCall || props.displayfollowUpPhoneCall || props.displayWinsPositiveOutcome ? false : true,
      csvExport: props.displayNeedToFollowUpList || props.displayHospitalAddmissionList || props.displayItIssuesList || props.displayFollowUpReminderList || props.displayReminderSentList || props.displayMonthlyCheckInPhoneCall || props.displayfollowUpPhoneCall || props.displayWinsPositiveOutcome ? false : true
    },
    {
      dataField: "organization",
      text: "Organization",
      sort: true,
      headerFormatter: priceFormatter,
      formatter: (cell, row) => {
        if (row.organization) {
          return row.organization;
        }else{
          return <div className="text-center">-</div>
        }
      },
      //hidden: props.displayCellularConnectivityList ? true : false,
      //csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "mainCareProviders",
      text: "Main Care Provider",
      sort: true,      
      headerFormatter: priceFormatter,
      formatter: (cell, row) => {
        if (row.mainCareProviders) {
          return row.mainCareProviders;
        }else{
          return <div className="text-center">-</div>
        }
      },
      //hidden: props.displayCellularConnectivityList ? true : false,
      //csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "enrolledPrograms",
      text: "Enrolled Program(s)",
      sort: true,
      formatter: (cell, row) => {
        if (row.enrolledPrograms) {
          return <div className="text-center">{row.enrolledPrograms}</div>;
        }else{
          return <div className="text-center">-</div>
        }
      }, 
      // hidden: props.displayCellularConnectivityList ? true : false,
      // csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "expectationsToFollow",
      text: "Client Expectations to Follow",
      formatter: (cell, row) => {
        return row.expectationsToFollow ? row.expectationsToFollow : '-';
      },
      csvFormatter: (cell, row) => {
        return row.expectationsToFollow ? row.expectationsToFollow : '-';
      },
      sort: true,
      headerFormatter: priceFormatter
    },
    {
      dataField: "totalCCMTrackingsTime",
      text: "Total CCM Time",
      formatter: (cell, row) => {
        return row.ccmTotalTimes ? row.ccmTotalTimes : "";
      },
      csvFormatter: (cell, row) => {
        return row.ccmTotalTimes ? row.ccmTotalTimes : "";
      },
      sort: true,
      hidden: props.displayCellularConnectivityList ? true : false,
      csvExport: props.displayCellularConnectivityList ? false : true
    },

    {
      dataField: "rpmTotalTimes",
      text: "Total RPM Time",
      formatter: (cell, row) => {
        return row.rpmTotalTimes ? row.rpmTotalTimes : "";
      },
      csvFormatter: (cell, row) => {
        return row.rpmTotalTimes ? row.rpmTotalTimes : "";
      },
      sort: true,
      hidden: props.displayCellularConnectivityList ? true : false,
      csvExport: props.displayCellularConnectivityList ? false : true
    },
    {
      dataField: "adhenrenceDay",
      text: "Adherence Days",
      formatter: (cell, row) => {
        return row.adhenrenceDay ? row.adhenrenceDay : 0;
      },
      sort: false,
      headerFormatter: priceFormatter
    },

    {
      dataField: "weekAssigned",
      text: "Designated Week",
      formatter: (cell, row) => {
        if(row.weekAssigned){
          return <div className='text-center'>{ row.weekAssigned }</div>;
        }else{
          return <div className='text-center'>-</div>;
        }
      },
      csvFormatter: (cell, row) => {
        return row.weekAssigned ? row.weekAssigned : "";
      },
      sort: true,
      hidden: props.displayCellularConnectivityList ? true : false,
      csvExport: props.displayCellularConnectivityList ? false : true
    },

    {
      dataField: "bodytraceBPIMEI",
      text: "BP IMEI",
      sort: true,
      headerFormatter: priceFormatter,
      hidden: props.displayCellularConnectivityList ? false : true,
      csvExport: props.displayCellularConnectivityList ? true : false
    },
    {
      dataField: "bodytraceWSIMEI",
      text: "WS IMEI",
      sort: true,
      headerFormatter: priceFormatter,
      hidden: props.displayCellularConnectivityList ? false : true,
      csvExport: props.displayCellularConnectivityList ? true : false
    },
    {
      dataField: "called",
      text: "Called",
      sort: false,
      formatter: (cell, row, rowIndex, extra) => {
        return (
          <div className="text-center">
            {row.called && (
              <img src={callingIcon} />
            )}
            {!row.called && (
              <div style={{textAlign:"center"}}>-</div>
            )}
          </div>
        );
      },
      formatExtraData: props,
      csvFormatter: (cell, row) => {
        return row.called ? true : false;
      }
    }
  ];
  const NoDataIndication = () => (
    <div>
      {props.loading && (
        <LottieLoader
          loadLoop={true}
          autoplayLoop={true}
          source={lottieLoaderFile}
          Lheight={150}
          Lwidth={150}
          subTitle={"Please Wait ..."}
        />
      )}
      {!props.loading && (
        <LottieLoader
          loadLoop={false}
          autoplayLoop={true}
          source={lottieEmptyFile}
          Lheight={300}
          Lwidth={300}
          title={"Sorry! No patient found :("}
          subTitle={"We can't find any patient."}
        />
      )}              
    </div>
  );
  return (
    <Row className="col-sm-12 main-cls-modal remove-table-padding">
      <Col sm="12" className="mt-12" style={{overflowX : 'auto'}}>
        <div className='scrollbar-table-cls'>
        <BootstrapTable
          remote={{ 
            sort: false,
            pagination:true,
            filter:true,
            search:true
           } 
          }
          keyField="_id"
          loading={props.loading}
          data={props.data}
          columns={columns}
          pagination={paginationFactory(options)}
          onTableChange={props.onTableChange}
          noDataIndication={ () => <NoDataIndication /> }
          hover={props.totalSize > 0 ? true : false}
          condensed
          bordered
          wrapperClasses="table-responsive"
          expandRow={{
            renderer: (row) => 
              rowComponent(row, props, props.profileOwner),
            onlyOneExpanding: false,
            showExpandColumn: true,
            expandByColumnOnly: false
          }}
        />
        </div>
      </Col>
    </Row>
  );
};
const rowComponent = (row, props, profile) => {
  const readingSubTypes = props?.readingSubTypes ? props.readingSubTypes : [];
  // If WINS tab is active and no reminder-list flags are set, render a WINS-specific notes table
  if (
    props.displayWinsPositiveOutcome &&
    !(props.displayReminderSentList || props.displayFollowUpReminderList || props.displayfollowUpPhoneCall || props.displayMonthlyCheckInPhoneCall)
  ) {
    const patient = row;
    const winsNotes = (row.notes || []).filter(n => {
      if (!n || !n.subject) return false;
      const s = (n.subject || '').toLowerCase().replace(/\s+/g, ' ').trim();
      return s === 'wins - positive outcome' || (s.includes('wins') && s.includes('positive'));
    });
    let readingsHeader = "No wins notes for this patient";
    if (_.size(winsNotes) > 0) readingsHeader = 'WINS / Positive Outcome History';
    return (
      <div>
        <Row style={{ margin: "15px 0px" }}>
          <Col sm="12" className="mt-2 remove-summary-paddding">
            <Card style={{ border: "0px 10px 10px 0px" }}>
              <CardHeader className="text-center summary-title summary-header">
                {capitalize(row?.fname || '')} {capitalize(row?.lname || '')} - {readingsHeader}
                <Link
                  to={`/dashboard/${row.fname
                    .replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '')
                    .toLowerCase()}-${row.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${row._id}?tab=4`}
                  className="btn pull-right more-btn "
                >
                  <i className="mdi mdi-account-card-details"></i> More Details
                </Link>
              </CardHeader>
              {winsNotes && winsNotes.length > 0 && (
                <CardBody className='padding-card-body'>
                  <div className="scrollbar-table-cls">
                    <BootstrapTable
                      keyField='_id'
                      data={winsNotes}
                      columns={[
                        {
                          dataField: 'createdBy',
                          text: 'Created By',
                          formatter: (cell) => {
                            const user = getSenderUser(cell);
                            const profileImg = user && user.profileImage ? user.profileImage : userImage;
                            const name = formatSenderDisplayName(cell);
                            return (
                              <div className={user && user.isActive ? "" : " text-danger"}>
                                <p style={{margin:0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                  <img src={profileImg} className="mr-2" alt="image" onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src = userImage; }}/>
                                  {name}
                                </p>
                              </div>
                            );
                          },
                          sort: false,
                          headerStyle: (colum, colIndex) => ({ width: '240px', whiteSpace: 'nowrap' }),
                          style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                          dataField: 'createdAt',
                          text: 'Date Created',
                          formatter: (cell) => (cell ? moment(cell).format('MMMM DD, YYYY hh:mm A') : '-'),
                          sort: false,
                          headerStyle: (colum, colIndex) => ({ width: '240px', whiteSpace: 'nowrap' }),
                          style: { whiteSpace: 'nowrap' }
                        },
                        {
                          dataField: 'subject',
                          text: 'Wins Note Title',
                          formatter: (cell) => (cell ? <p style={{margin:0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{cell}</p> : <div className='text-center'>-</div>),
                          sort: false,
                          headerStyle: (colum, colIndex) => ({ width: '300px', whiteSpace: 'nowrap' }),
                          style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                          dataField: 'mainCareProvider',
                          text: 'Main Care Provider',
                          formatter: (cell, noteRow) => {
                            const m = patient && (patient.mainCareProviders || patient.mainCareProviders === 0) ? patient.mainCareProviders : null;
                            if (!m) return <div className='text-center'>-</div>;
                            if (Array.isArray(m)) return <div>{m.join(', ')}</div>;
                            return <div>{m}</div>;
                          },
                          sort: false,
                          headerStyle: (colum, colIndex) => ({ width: '220px', whiteSpace: 'nowrap' }),
                          style: { whiteSpace: 'normal', wordBreak: 'break-word' }
                        },
                        {
                          dataField: 'body',
                          text: 'Message',
                          formatter: (cell) => (cell ? <div><p style={{margin:0}}>{cell}</p></div> : <div className='text-center'>-</div>),
                          sort: false,
                          headerStyle: (colum, colIndex) => ({ minWidth: '420px' }),
                          style: { whiteSpace: 'normal', wordBreak: 'break-word' }
                        }
                      ]}
                    />
                  </div>
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  if(props.displayReminderSentList || props.displayFollowUpReminderList || props.displayfollowUpPhoneCall || props.displayMonthlyCheckInPhoneCall){
      let readingsHeader = "No reminders notes for this patient";
      if(_.size(row.notes)> 0){
        readingsHeader = 'Reminder History'
      }
      return(
        <div>
          <Row style={{ margin: "15px 0px" }}>
            <Col sm="12" className="mt-2 remove-summary-paddding">
              <Card style={{ border: "0px 10px 10px 0px" }}>
              <CardHeader className="text-center summary-title summary-header">
              {capitalize(row?.fname || '')} {capitalize(row?.lname || '')} - {readingsHeader}
              <Link
              to={`/dashboard/${row.fname
                .replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '')
                .toLowerCase()}-${row.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${row._id
                }`}
              className="btn pull-right more-btn "
            >
              <i class="mdi mdi-account-card-details"></i> More Details
            </Link>
              </CardHeader>
               {row && row.notes && row.notes.length > 0 && (
                <CardBody className='padding-card-body'>
                <div className="scrollbar-table-cls">
                <BootstrapTable
                  keyField='_id'
                  data={row.notes}
                  columns={[
                    {
                      dataField: 'senderData',
                      text: 'Created By',
                      formatter: (cell, row) => {
                        const user = getSenderUser(cell);
                        const profile = (user && user.profileImage) ? user.profileImage : userImage;
                        const name = formatSenderDisplayName(cell);
                        return(
                          <div className={user && user.isActive ? "" : " text-danger"}>
                          <p>
                            <img src={profile} className="mr-2" alt="image"   
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = userImage;
                            }}/>
                            {name}
                          </p>
                        </div>
                        )
                      },
                      sort: false
                    },
                    {
                      dataField: 'subject',
                      text: 'Subject',
                      formatter: (cell, row) => {
                        if(cell){
                          const dataString = cell
                          return(
                            <div >
                             <p>{dataString}</p>
                          </div>
                          )
                        }else{
                          return (<div> "-" </div>)
                        }
                      },
                      sort: false
                    },
                    {
                      dataField: 'reminderNoteData',
                      text: 'Notify On',
                      formatter: (cell, row) => {
                        if(cell.patientStatus == 'Reminder sent one hour before' || cell.patientStatus == 'Reminder sent one day before'){
                        const patientReminder = ['Inbox'];
                        if( row.reminderNoteData.reminderSentPatinet && row.reminderNoteData.reminderSentPatinet.recepientEmail){
                        patientReminder.push('Email');
                        }
                        if( row.reminderNoteData.reminderSentPatinet && row.reminderNoteData.reminderSentPatinet.recepientPhone){
                        patientReminder.push('Sms');
                        }
                        const dataString = patientReminder.join(', ');
                          return(
                            <div >
                             <p>{dataString}</p>
                          </div>
                          )
                        }else if(cell && cell.notifyMe && cell.notifyMe.length){
                          const dataString = cell.notifyMe.join(', ');
                          return(
                            <div >
                             <p>{dataString}</p>
                          </div>
                          )
                        }else{
                          return (<div> - </div>)
                        }
                      },
                      sort: false
                    },
                    {
                      dataField: 'reminderNoteData',
                      text: 'Reminder Sent To',
                      formatter: (cell, row) => {
                        if(cell.patientStatus == 'Reminder sent one hour before' || cell.patientStatus == 'Reminder sent one day before'){
                          let email = null;
                          let sms = null;
                            email = cell.reminderSentPatinet && cell.reminderSentPatinet.recepientEmail ? cell.reminderSentPatinet.recepientEmail : null;
                            sms = cell.reminderSentPatinet &&  cell.reminderSentPatinet.recepientPhone ? cell.reminderSentPatinet.recepientPhone : null
                          const returnValue = []
                          if(sms){
                            returnValue.push(<p>{sms}</p>)
                          }
                          if(email){
                            returnValue.push(<p>{email}</p>)
                          }
                          if(cell.notifyMe.includes('Inbox')){
                            returnValue.push(<p>Inbox</p>)
                          }
                          return  returnValue
                        }else if(cell && cell.reminderSent && (cell.status == 'Sent')){
                          let email = null;
                          let sms = null;
                          if(cell.notifyMe.includes('Email')){
                            email = cell.reminderSent &&  cell.reminderSent.recepientEmail || ''
                          }if(cell.notifyMe.includes('Sms')){
                            sms = cell.reminderSent &&  cell.reminderSent.recepientPhone || ''
                          }
                          const returnValue = []
                          if(sms){
                            returnValue.push(<p>{sms}</p>)
                          }
                          if(email){
                            returnValue.push(<p>{email}</p>)
                          }
                          if(cell.notifyMe.includes('Inbox')){
                            returnValue.push(<p>Inbox</p>)
                          }
                          return returnValue
                        }else{
                          return (<div> - </div>)
                        }
                      },
                      sort: false,
                      hidden: props.displayReminderSentList ? false : true
                    },
                    {
                      dataField: 'reminderNoteData',
                      text: props.displayReminderSentList ? 'Reminder Sent Date' : 'Reminder Date',
                      formatter: (cell, row) => {
                        if(cell && cell.reminderDate){
                          if(cell?.reminderSentDate){
                            const dataString = cell.reminderSentDate;
                            return(
                              <div >
                               <p>{moment(dataString).format("MMMM DD, YYYY hh:mm A")}</p>
                            </div>
                            )
                          }else{
                            const dataString = cell.reminderDate;
                            return(
                              <div >
                               <p>{moment(dataString).format("MMMM DD, YYYY hh:mm A")}</p>
                            </div>
                            )
                          }
                        }else{
                          return (<div> "-" </div>)
                        }
                      },
                      sort: false
                    },
                    {
                      dataField: 'body',
                      text: 'Message',
                      formatter: (cell, row) => {
                        let message = '-';
                        if(cell){
                        message = cell;
                        }
                        if((row.subject == 'Follow Up Phone Call' || row.subject == 'Monthly Check in Phone Call') && row.reminderNoteData.oneDayRemindMessgae && row.reminderNoteData.oneHourRemindMessgae){
                        return (<div>
                        <p><b>One Day reminder message : </b>{row.reminderNoteData.oneDayRemindMessgae}</p>
                        <p><b>One Hour reminder message : </b>{row.reminderNoteData.oneHourRemindMessgae}</p>
                        </div>)
                        }else if((row.subject == 'Follow Up Phone Call' || row.subject == 'Monthly Check in Phone Call') && row.reminderNoteData.oneHourRemindMessgae){
                        return (<div>
                        <p><b>One Hour reminder message : </b>{row.reminderNoteData.oneHourRemindMessgae}</p>
                        </div>)
                        }
                        return (<div><p>{message}</p></div>)
                      },
                      sort: false
                    },
                    {
                      dataField: 'reminderNoteData',
                      text: 'Status',
                      formatter: (cell, row) => {
                        if(cell && cell.status){
                          const dataString = cell.status == 'Reminder' ? 'Reminder Pending' : cell.status == 'Completed' ? 'Follow Up Completed' : cell.status;
                          let condition;
                          if(cell.status == 'Reminder'){
                          condition = <span class="badge" style={{'fontSize' : '90%', 'color' : 'white', background : '#FFA500'}}>Reminder Pending</span>
                          }else if(cell.status == 'Completed'){
                            condition = <span class="badge bg-info" style={{'fontSize' : '90%', 'color' : 'white'}}>Follow Up Completed</span>
                          }else if(cell.patientStatus == 'Reminder sent one day before'){
                          condition = (
                          <>
                            <span 
                              className="badge bg-success" 
                              style={{ fontSize: '90%', color: 'white', display: 'block', marginBottom: '3px' }}
                            >
                              One Day Reminder Sent
                            </span>
                            <span 
                              className="badge" 
                              style={{ fontSize: '90%', color: 'white', display: 'block', background : '#FFA500' }}
                            >
                              One Hour Reminder Pending
                            </span>
                          </>
                          );
                          }else if(cell.patientStatus == 'Reminder sent one hour before'){
                           condition = (
                            <>
                              {(row.reminderNoteData && row.reminderNoteData.oneDayRemindMessgae) && (<span 
                                className="badge bg-success" 
                                style={{ fontSize: '90%', color: 'white', display: 'block', marginBottom: '3px' }}
                              >
                                One Day Reminder Sent
                              </span>)}
                              <span 
                                className="badge bg-success" 
                                style={{ fontSize: '90%', color: 'white', display: 'block' }}
                              >
                                One Hour Reminder Sent
                              </span>
                            </>
                            );
                          } else{
                            condition = <span class="badge bg-success" style={{'fontSize' : '90%', 'color' : 'white'}}>{cell.status}</span>
                          }
                          return(
                            <div>
                             {condition}
                          </div>
                          )
                        }else{
                          return (<div> "-" </div>)
                        }
                      },
                      sort: false
                    }
                 ]}
                />
                </div>
              </CardBody>
               )}
              </Card>
            </Col>
          </Row>
      </div>
      )
    }else{
    let readingsHeader = "No readings in the Last 30 Days";
    if (_.size(row.readingsSevenDays) > 0 || _.size(row.bodyTraceReadings) > 0) {
      readingsHeader = "Last 30 Days Summary";
    }
    const readingSubType = readingSubTypes.filter((item) => item.description !== "Weight Difference");
    return (
      <div>
        <Card className="remove-card-shadow remove-card-radius">
          <CardHeader className="text-center summary-title summary-header">
            <div>
              {(_.size(row.readingsSevenDays) == 0 && _.size(row.bodyTraceReadings) == 0) && (
                <>
                  <div className="summary-div-center">
                    <LottieLoader
                      loadLoop={false}
                      autoplayLoop={true}
                      source={lottieEmptyFile}
                      Lheight={200}
                      Lwidth={200}
                      titleSmall={"Sorry! No last 30 days summary found :("}
                      subTitleSmall={"We can't find any reading's for last 30 days."}
                    />
                    <Link
                      to={`/dashboard/${row.fname
                        .replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '')
                        .toLowerCase()}-${row.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${row._id
                        }`}
                      className="btn pull-center more-btn"
                      style={{ marginTop: 10 }}
                    >
                      <i class="mdi mdi-account-card-details"></i> More Details
                    </Link>
                  </div>
                </>
              )}
              {(_.size(row.readingsSevenDays) > 0 || _.size(row.bodyTraceReadings) > 0) && (
                <>
                {capitalize(row?.fname || '')} {capitalize(row?.lname || '')} - {readingsHeader}
                  <Link
                    to={`/dashboard/${row.fname
                      .replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '')
                      .toLowerCase()}-${row.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${row._id
                      }`}
                    className="btn pull-right more-btn "
                  >
                    <i class="mdi mdi-account-card-details"></i> More Details
                  </Link>
                </>
              )}
            </div>
          </CardHeader>
        </Card>
        <Row style={{ margin: "15px 0px" }}>
          {readingSubType.map((value, i) => {
            // this added code for heart rate take from puls ox filter(HeartRateFromPulsOx)
            if (row.isBloodPressureReading && value && value._id == '5be56cbe3863cd0647d79896') {
              return;
            }
            // finished puls ox filter code(HeartRateFromPulsOx)
            var result = _.includes(value.abbrev, "BT_");
            var readings = undefined;
            var readingValue = undefined
            var checkThis = undefined
            if (result) {
              readings = _.filter(row.bodyTraceReadings, (reading) => {
                if (_.includes(value.abbrev, "WS") && reading.values.unit == 0) {
                  return false;
                } else if (value.name.toLowerCase() in reading.values) {
                  return true;
                }
                return false;
              });
              readingValue = _.map(readings, "values");
              checkThis = _.map(readingValue, (readingIndex, i) => {
                return _.get(readingValue[i], value.name.toLowerCase());
              });
  
            } else {
              readings = _.filter(row.readingsSevenDays, {
                readingType: value.reading
              });
              readingValue = _.map(readings, "value");
              checkThis = _.map(readingValue, (readingIndex) => {
                return readingIndex[value.index];
              });
            }
  
            if (value.name === "Mean Arterial") {
              checkThis = _.map(readingValue, (readingIndex) => {
                return _.round(
                  (1 / 3) * readingIndex[0] + (2 / 3) * readingIndex[1],
                  2
                );
              });
            }
            var checkNan = isNaN(_.min(checkThis));
            if (readings.length === 0 || checkNan) return;
            var latestReading = _.first(_.orderBy(readings, ['deviceReadingDate'], ['desc']));
            var getTheValueLatest;
            if (_.has(latestReading, "value")) {
              getTheValueLatest = _.pick(latestReading, "value");
            } else {
              getTheValueLatest = _.pick(latestReading, "values");
            }
            var latestResult
            if (_.has(latestReading, "value")) {
              latestResult = getTheValueLatest.value[value.index];
              if (value.name === "Mean Arterial") {
                latestResult = Math.round(
                  _.round(
                    (1 / 3) * getTheValueLatest.value[0] +
                    (2 / 3) * getTheValueLatest.value[1],
                    2
                  )
                );
              }
            } else {
              latestResult = _.get(getTheValueLatest.values, value.name.toLowerCase());
              if (value.name === "Mean Arterial") {
                latestResult = Math.round(
                  _.round(
                    (1 / 3) * _.get(getTheValueLatest.values, "systolic") +
                    (2 / 3) * _.get(getTheValueLatest.values, "diastolic"),
                    2
                  )
                );
              }
            }
            var lastSevenDays = _.size(readings);
            var lastTestTaken =
              readings.length > 0 &&
              moment(latestReading.deviceReadingDate).format("MM/DD/YY"); // hh:mm A
  
            var matchingExpectationsBreached = _.filter(
              row.expectations,
              function (o) {
                return (
                  o &&
                  o && o.readingSubType.toLowerCase() == _.replace(_.replace(value.name, "Pulse", "Heart Rate").toLowerCase(), "bpm", "Heart Rate").toLowerCase() &&
                  !o.name.toLowerCase().includes("Event".toLowerCase())
                );
              }
            );
            // Checked all of the readings to see which had a low threshold.
            var lowExpectation = _.flatMap(_(matchingExpectationsBreached)
              .filter((o) => o && o.condition == "<=" || o.condition == "between")
              .flatMap((_value, i) => _.pick(_value, "valueProperty"))
              .value(), "valueProperty");
  
            var highExpectation = _.flatMap(_(matchingExpectationsBreached)
              .filter((o) => o && o.condition == ">=" || o.condition == "between")
              .flatMap((_value, i) => _.pick(_value, "valueProperty"))
              .value(), "valueProperty");
  
            var lowMinThreshold = _.maxBy(_.map(lowExpectation, i => i.minValue || i.value), function (o) { return o && parseInt(o) });
            var highMaxThreshold = _.minBy(_.map(highExpectation, i => i.maxValue || i.value), function (o) { return o && parseInt(o) });
  
            var lowThreshold = _.filter(checkThis, (reading, i) => {
              if (lowMinThreshold != undefined) {
                return lowMinThreshold != undefined ? reading <= lowMinThreshold : reading <= lowMinThreshold;
              } else {
                return false;
              }
            });
            // Checked all of the readings to see which had a high threshold.
            var highThreshold = _.filter(checkThis, (reading, i) => {
              if (highMaxThreshold != undefined) {
                return highMaxThreshold != undefined ? reading >= highMaxThreshold : reading >= highMaxThreshold;
              } else {
                return false;
              }
            });
  
            var countLowThreshold = Math.round(
              (_.size(lowThreshold) / lastSevenDays) * 100
            );
            var countHighThreshold = Math.round(
              (_.size(highThreshold) / lastSevenDays) * 100
            );
            var goodThreshold = Math.round(
              100 -
              (parseFloat(countLowThreshold) + parseFloat(countHighThreshold))
            );
            var sevenDaysLowest =
              value.name != "Body Temperature"
                ? Math.round(_.min(checkThis))
                : _.min(checkThis).toFixed(2);
            var sevenDaysHighest =
              value.name != "Body Temperature"
                ? Math.round(_.max(checkThis))
                : _.max(checkThis).toFixed(2);
            var sevenDaysAverage =
              value.name != "Body Temperature"
                ? Math.round(_.mean(checkThis))
                : _.mean(checkThis).toFixed(2);
            if (value.name == "Body Temperature") {
              latestResult = ((latestResult * 9) / 5 + 32).toFixed(2);
              sevenDaysLowest = ((sevenDaysLowest * 9) / 5 + 32).toFixed(2);
              sevenDaysHighest = ((sevenDaysHighest * 9) / 5 + 32).toFixed(2);
              sevenDaysAverage = ((sevenDaysAverage * 9) / 5 + 32).toFixed(2);
            }
            if (value.name == "Weight") {
              if(value.abbrev == "BT_WS"){
                latestResult = Math.round(latestResult);
                sevenDaysLowest = Math.round(sevenDaysLowest);
                sevenDaysHighest = Math.round(sevenDaysHighest);
                sevenDaysAverage = Math.round(sevenDaysAverage);
              }else{
                latestResult = Math.round(latestResult * 2.2046);
                sevenDaysLowest = Math.round(sevenDaysLowest * 2.2046);
                sevenDaysHighest = Math.round(sevenDaysHighest * 2.2046);
                sevenDaysAverage = Math.round(sevenDaysAverage * 2.2046);
              }
            } else {
              latestResult = Math.round(latestResult);
            }
            var readingName = _.replace(value.name, "Pulse", "Heart Rate");
            return (
              <Col sm="4" className="mt-2 remove-summary-paddding">
                <Card style={{ border: "0px 10px 10px 0px" }}>
                  <CardHeader className="text-white" style={{ padding: "3px 0px" }}>
                    <div class="col-12">
                      <div>
                        <div className="text-left reading-card-for-all-reading">
                          <img
                            src={require(`../../../files/Reading/${value.abbrev}.svg`)}
                            alt="profile-image"
                            className="profile rounded-circle img-fluid mr-2 reading-icon-summary"
                          /> <div>
                            <h4 class="reading-card-title" style={{ color: "black", fontSize: 14, fontFamily: "ubuntu-regular", fontWeight: "700" }}>{readingName}</h4>
                            <h6 class="reading-card-subtitle" style={{ color: "#787878", fontSize: 14, fontFamily: "ubuntu-regular", fontWeight: "500" }}>{`${value.description}`}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className='padding-card-body'>
                    <Row className="mb-2">
                      <Col sm="8">No. of Test taken in last 30 days:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {lastSevenDays || 0}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="8">Last Test Taken:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {lastTestTaken}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="8">Last Test Result:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {latestResult}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="8">30 days lowest:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {sevenDaysLowest || 0}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="8">30 days highest:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {sevenDaysHighest || 0}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="8">30 days average:</Col>
                      <Col sm="4" className="font-weight-bold">
                        {sevenDaysAverage || 0}
                      </Col>
                    </Row>
                    <>
                      {matchingExpectationsBreached == undefined || matchingExpectationsBreached.length == 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% High:</Col>
                          <Col
                            sm="4"
                            className="font-weight-bold"
                            style={{ color: "black" }}
                          >
                            Not included in Care Plan
                          </Col>
                        </Row>
                      )}
                      {matchingExpectationsBreached !== undefined && matchingExpectationsBreached.length > 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% High:</Col>
                          <Col sm="4" className="font-weight-bold">
                            {countHighThreshold || 0}%
                          </Col>
                        </Row>
                      )}
                      {matchingExpectationsBreached == undefined || matchingExpectationsBreached.length == 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% Low:</Col>
                          <Col
                            sm="4"
                            className="font-weight-bold"
                            style={{ color: "black" }}
                          >
                            Not included in Care Plan
                          </Col>
                        </Row>
                      )}
                      {matchingExpectationsBreached !== undefined && matchingExpectationsBreached.length > 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% Low</Col>
                          <Col sm="4" className="font-weight-bold">
                            {countLowThreshold || 0}%
                          </Col>
                        </Row>
                      )}
                      {matchingExpectationsBreached == undefined || matchingExpectationsBreached.length == 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% Good(InRange):</Col>
                          <Col
                            sm="4"
                            className="font-weight-bold"
                            style={{ color: "black" }}
                          >
                            Not included in Care Plan
                          </Col>
                        </Row>
                      )}
                      {matchingExpectationsBreached !== undefined && matchingExpectationsBreached.length > 0 && (
                        <Row className="mb-2">
                          <Col sm="8">% Good(InRange)</Col>
                          <Col sm="4" className="font-weight-bold">
                            {goodThreshold || 0}%
                          </Col>
                        </Row>
                      )}
                    </>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
};
ImprovedPatientList.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};
export default ImprovedPatientList;